import metrics, { IMetric } from 'maps/metrics';

export default getTableHeaders;

function getTableHeaders(
  browseEntityType: string,
  tableHeadersType?: string
): ({ label: string; value: string } | IMetric)[] {
  if (browseEntityType === 'label') {
    return [
      { label: `${browseEntityType} name`, value: 'displayName' },
      metrics['grouped_track_count'],
      metrics['grouped_album_count'],
      metrics['artist_count'],
    ];
  }
  if (tableHeadersType === 'standard') {
    return [
      {
        label: `${browseEntityType} info`,
        value: 'displayName',
        key: `displayName`,
      },
      metrics['performance_this_week_to_date'],
      metrics['performance_last_week_to_date'],
      metrics['this_week_to_date_range'],

      metrics['performance_last_week'],
      metrics['performance_last_last_week'],
      metrics['performance_last_week_range'],

      metrics['performance_rtd'],
    ];
  }
  if (tableHeadersType === 'Browse Opus') {
    return [
      {
        label: `${browseEntityType} info`,
        value: 'displayName',
        key: `displayName`,
      },
      metrics['performance_this_week_to_date'],
      metrics['this_week_to_date_range'],

      metrics['performance_last_week'],
      metrics['performance_last_week_range'],

      metrics['performance_rtd'],
    ];
  }
  if (tableHeadersType === 'toplists') {
    return [
      {
        label: `${browseEntityType} info`,
        value: 'displayName',
        key: `displayName`,
      },
      metrics['performance_this_week_to_date'],
      metrics['performance_last_week_to_date'],
      metrics['this_week_to_date_range'],
    ];
  }

  return [
    { label: `${browseEntityType} name`, value: 'displayName' },
    metrics['performance_this_week_to_date'],
    metrics['performance_last_week'],
    metrics['performance_rtd'],
  ];
}
